import React, { useState } from "react";
import moment from "moment";
import alertIcon from "../../../assets/icons/Attention2.svg";

const SingleAlert = ({ employee, task, indexNumber }) => {
  const [hover, setHover] = useState(false);
  const totalWidth = `${+task?.width?.split("%")[0] + +task?.left?.split("%")[0]}`;
  const alertPosition = `${
    +task?.left?.split("%")?.[0] + 1.75 + (indexNumber > 1 && indexNumber * (1.75 * 1.075))
  }`;
  if (employee?.notavailable?.length === 0) return;
  const notAvailable = employee?.notavailable?.find(
    (item) =>
      (moment(item?.startingDate).isSameOrAfter(task?.startingDate) &&
        moment(item?.startingDate).isSameOrBefore(moment(task?.endDate))) ||
      (moment(item?.lastDay).isSameOrAfter(moment(task?.startingDate)) &&
        moment(item?.lastDay).isSameOrBefore(moment(task?.endDate)))
  );
  if (!notAvailable) return;
  return (
    <div
      className="task-line-asignee-attention"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        left: `${+totalWidth <= +alertPosition ? totalWidth : alertPosition}%`,
        display: task?.display,
      }}
    >
      <img src={alertIcon} onMouseEnter={() => setHover(true)} style={{ cursor: "pointer" }} />
      {hover && (
        <div className="task-line-attention-text">
          {employee?.firstname && employee?.firstname} {employee?.lastname && employee?.lastname} is
          unavailable till <p>{moment.utc(notAvailable?.lastDay).local().format("DD MMM YYYY")}</p>
        </div>
      )}
    </div>
  );
};

export default SingleAlert;
